<template>
	<div>
		<v-data-table :items="items" :headers="colunas" hide-default-footer :server-items-length="totalItens">
			<template #item.siglaOrgao="{ item }">
				<div class="d-flex justify-space-evenly">
					<icone-tooltip
						v-if="item.adesaoExterna"
						icone="mdi-file-import-outline"
						cor="primary"
						texto="Adesão Pública"
						tamanho="20px"
					></icone-tooltip>
					<div class="d-flex ml-1 flex-column align-content-stretch">
						<texto-tooltip :texto="item.siglaOrgao" :tamanho-maximo="10"></texto-tooltip>
					</div>
				</div>
			</template>
			<template #item.dataCadastro="{ item }">
				{{ item.dataCadastro | azDate }}
			</template>
			<template #item.atividade="{ item }">
				<div class="d-flex flex-column align-content-stretch">
					<span>{{ item.atividadeNome }}</span>
					<span v-if="!!item.utilizaFluxo">{{ item.atividadeSituacao }}</span>
				</div>
			</template>
			<template #item.acoes="{ item }">
				<botao-tooltip
					icone="mdi-login"
					cor="grey"
					texto="Acessar"
					@click="acessar(item.id, 'editar')"
				></botao-tooltip>
			</template>
		</v-data-table>
		<paginacao-tabela
			v-if="hasItens"
			:page.sync="paginacaoAdesoes.page"
			:rows-per-page.sync="paginacaoAdesoes.rowsPerPage"
			:totalPaginas="totalPaginas"
			:totalItens="totalItens"
			@resetar-page="resetarPage"
		></paginacao-tabela>
	</div>
</template>
<script>
import PaginacaoListagem from '@/core/store/default/paginacaoListagem'
import { TabelaColunaUtils } from '@/core/utils'
import { actionTypes, routesNames, situacoes } from '@/core/constants'
import IconeSimplesRedondoComLabel from '@/views/components/icones/IconeSimplesRedondoComLabel.vue'
import { mapState } from 'vuex'

export default {
	name: 'listagem-adesoes-interna-collapses',
	components: { IconeSimplesRedondoComLabel },
	props: {
		idAta: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			paginacaoAdesoes: PaginacaoListagem('id', 5, 'desc'),
			items: [],
			totalPaginas: 0,
			totalItens: 0,
			colunas: [
				new TabelaColunaUtils('Órgão', 'siglaOrgao', '10%'),
				new TabelaColunaUtils('Data', 'dataCadastro', '10%'),
				new TabelaColunaUtils('Usuário', 'usuario', '30%'),
				new TabelaColunaUtils('Atividade', 'atividade', '25%'),
				new TabelaColunaUtils('Ações', 'acoes', '5%'),
			],
		}
	},
	computed: {
		hasItens() {
			return this.totalItens > 0
		},
		...mapState({
			idAtividadeAdesao: (state) => state.ata.idAtividadeAdesao.value,
		}),
	},
	watch: {
		paginacaoAdesoes: {
			async handler() {
				await this.carregarAdesoes()
			},
			deep: true,
		},
		idAtividadeAdesao: {
			async handler() {
				await this.carregarAdesoes()
			},
		},
	},
	async mounted() {
		await this.carregarAdesoes()
	},
	methods: {
		async carregarAdesoes() {
			let retorno = await this.$store.dispatch(actionTypes.ADESAO.BUSCAR_ADESOES_POR_ATA, {
				idAta: this.idAta,
				idAtividadeAdesao: this.idAtividadeAdesao,
				paginacao: this.paginacaoAdesoes,
			})

			this.items = retorno.itens
			this.totalPaginas = retorno.totalPages
			this.totalItens = retorno.totalElements
		},
		acessar(idAdesao) {
			this.$router.push({ name: routesNames.ADESAO.ADESAO_VIEW, params: { id: idAdesao } })
		},
		resetarPage() {
			this.paginacaoAdesoes.page = 1
		},
		getSituacoesAdesao() {
			return situacoes.ADESAO
		},
		estaAguardandoAnalise(situacao) {
			return situacao === situacoes.ADESAO.ENVIADO_ANALISE.value
		},
	},
}
</script>
<style scoped lang="stylus">
.aguardando-analise
	color #ff9800
	font-weight bold
</style>
